import { render, staticRenderFns } from "./FleetDetailFtpRsync.vue?vue&type=template&id=2b8765c1"
import script from "./FleetDetailFtpRsync.vue?vue&type=script&setup=true&lang=ts"
export * from "./FleetDetailFtpRsync.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports